import axios from "@/plugins/axios";

import * as companies from "./companies";
import * as workers from "./workers";

export const user = {
    ...companies,
    ...workers
}